<template>
    <div class="tablePage">
        <el-table
            v-loading="loading"
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            :header-cell-style="headCellStyle"
            stripe
            :height="tableHeight"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" width="50" />
            <el-table-column v-if='isSys' prop="scopeName"  :label="$t('public.table_scope')" show-overflow-tooltip />
            <el-table-column prop="tagId" :label="$t('integration.number')" show-overflow-tooltip>
                <template #default="{ row }">
                    <span>
                        <i v-icon:theme="['sensorTypeConvert', row.type]"></i>
                        <!-- <i :class="sensorTypeConvert(row.type).icon" style="margin-right: 5px; cursor: pointer"
              :title="$t(sensorTypeConvert(row.type).title)"></i> -->
                        <el-popover placement="top-start" width="auto" trigger="hover">
                            <v-popoer :rowData="row" :typeWay="typeWay" />

                            <span slot="reference">{{ row.tagId }}</span>
                        </el-popover>
                    </span>
                </template>
            </el-table-column>

            <!-- 除了未确认都存在 -->
            <el-table-column prop="gatewayName" :label="$t('device.forward_gateway')" show-overflow-tooltip>
                <template #default="{ row }">
                    <span style="cursor: pointer" @click="gatwayDetail(row.gatewayId)">
                        {{ row.gatewayName }}
                    </span>
                </template>
            </el-table-column>

          <!--  架构与监测点类型只有已绑定 停止使用存在 -->
          <!--            <el-table-column prop="sceneName" :label="$t('public.table_arch')" show-overflow-tooltip />-->
          <el-table-column prop="carrierName" :label="$t('public.table_carrier')" width='250px'>
            <template #default="{ row }">
              <CardSwipper :key='Math.random()' v-if='row.carrierName' :list='[row]'>
                <template #title='{item}'>
                  {{ item.sceneName }}
                </template>
                <template #default='{item}'>
                  <div class='uk-flex'>
                    <div style='width: 30px' class='bd-r uk-flex uk-flex-center'>
                      <i
                        :class="carrierTypeConvert(row.carrierType).icon"
                        class='uk-margin-remove'
                        :title="$t(carrierTypeConvert(row.carrierType).title)"
                        style="margin-right: 5px; cursor: pointer"
                        @click="carrierDetailFn(row)"
                        v-if="row.carrierType"
                      ></i>
                    </div>

                    <div class='uk-flex-1'>
                      {{ item.carrierName }}
                    </div>
                  </div>
                </template>

              </CardSwipper>
            </template>
          </el-table-column>

          <!-- 停用时间只存在停用状态 -->
          <el-table-column prop="stopTime" :label="$t('device.stop_time')" show-overflow-tooltip>
            <template #default="{ row }">
              <span>{{ $timetransition(row.stopTime) }}</span>
            </template>
          </el-table-column>
            <el-table-column prop="updateTime" :label="$t('public.update_time')" width="180" show-overflow-tooltip>
              <template #default='{row}'>
                {{$timetransition(row.updateTime)}}
              </template>
            </el-table-column>
            <el-table-column prop="optare" fixed='right' :label="$t('public.table_operation')" width="160" align="center">
                <template #default="{ row }">
                    <el-button type="text" size="small" v-for="item in optareBtn" :key="item.id" :title="$t(item.title)" :icon="item.icon" @click="handle(item.method, row)"></el-button>
                    <!-- v-has="item.vHas" -->
                </template>
            </el-table-column>
        </el-table>

      <GatewayDialog :visible.sync='gatewayVisible' :gateway-id='gatewayId'></GatewayDialog>
      <MonitorDialog :visible.sync='dialogVisible' :carrier-info='carrierDetail'></MonitorDialog>
    </div>
</template>

<script>
import popover from '../../Popover.vue'
import { carrierDetail } from '@/api/modules/carrier.js'
import { carrierTypeConvert } from '@/utils/convert'
import CardSwipper from '@/components/CardSwipper/CardSwipper.vue'
import MonitorDialog from '@/pages/equipment/publicCom/MonitorDialog.vue'
import { getIsSys } from '@/utils/permission'
import { ENUM_DEVICE_STATUS } from '@/common/enum/forward/device'
import GatewayDialog from '@/pages/equipment/publicCom/GatewayDialog.vue'
export default {
  name: 'Table',
  components: {
    GatewayDialog,
    MonitorDialog,
    CardSwipper,
    'v-popoer': popover
  },
  props: ['loading', 'tableData'],
  computed: {
    ENUM_SENSOR_STATUS () {
      return ENUM_DEVICE_STATUS
    },
    i18n () {
      return this.$i18n.locale
    },
    isSys () {
      return getIsSys()
    }
  },
  data () {
    return {
      gatewayVisible: false,
      gatewayId: 0,
      carrierTypeConvert,
      tableHeight: '100%',
      optareBtn: [
        // {
        //     id: 1,
        //     title: $t('public.config'),
        //     icon: 'el-icon-setting',
        //     vHas: [],
        //     method: 'configFn'
        // },
        {
          id: 2,
          title: $t('integration.modify_customer'),
          icon: 'el-icon-edit-outline',
          vHas: [],
          method: 'editScopeRowFn'
        },

        {
          id: 9,
          title: 'device.reuse',
          icon: 'el-icon-refresh-right',
          vHas: [],
          method: 'refreshFn'
        },
        {
          id: 3,
          title: 'public.details',
          icon: 'el-icon-tickets',
          vHas: [],
          method: 'detailFn'
        },
        {
          id: 5,
          title: $t('public.tbopt_delete'),
          icon: 'el-icon-delete',
          vHas: [],
          method: 'delRowFn'
        },
      ],
      dialogVisible: false,
      carrierDetail: null,
      // 默认为绑定状态
      typeWay: 'stop'
    }
  },
  mounted () {
    // if (!this.isSys) {
    //   this.optareBtn.splice(1, 1)
    // }
  },
  methods: {
    handleSelectionChange (arg) {
      this.$emit('choozeTable', arg)
    },
    handle (method, row) {
      this.$emit(method, row)
    },
    /** 数据状态 */
    styleFn (row) {
      if (row.status === 1) {
        return { color: '#65cea7', 'font-weight': 'bold', cursor: 'pointer' }
      } else {
        return { color: 'red', cursor: 'pointer' }
      }
    },
    /** 查找监测点详情 */
    carrierDetailFn (row) {
      carrierDetail(row.carrierType, row.carrierId)
        .then(({ result }) => {
          this.dialogVisible = true
          result.mac = row.gatewayMac
          this.carrierDetail = result
        })
    },
    /** 根据id获取监测点关联的网关信息 */
    gatwayDetail (id) {
      this.gatewayVisible = true
      this.gatewayId = id
    },
    // 校准图标hover字样内容
    contentFn(row){
      if(row.calibrationType === 1){
        return this.$t('device.calibration_expiration') + ':' + this.$timetransition(row.calibrationExpireTime, 'Y-M-D')
      }
      if(row.calibrationType === 0){
        return $t('device.no_calibration')
      }
      return $t('device.no_set_calibration')
    }
  }
}
</script>

<style lang="scss" scoped>
.tablePage {
    height: calc(100% - 60px);
}
</style>
